import { Paths } from "@/util/paths";
import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import AppSettings from "@/modules/app-settings";
import { ApplicationViews } from "@/util/enum";

export const TeachingActivitiesResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const actions: Promise<void>[] = [];
	const appSetting = getModule(AppSettings) as AppSettings;
	if (to.path == Paths.TeachingActivities) {
		appSetting.setChildMenu(ApplicationViews.TeachingActivities);
	}
	await Promise.all(actions);
	next();
};
